import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ConfigService} from '../../../../shared/services/config.service';
import {UserService} from '../../../../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentDashboardService {

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) {  }

  private get httpOptions() {
    let sessionId = "";
    if (typeof (this.userService) !== "undefined" && this.userService != null && typeof (this.userService.sessionId) !== "undefined" && this.userService != null) {
      sessionId = this.userService.sessionId;
    }
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-document-key',
        'SessionId': sessionId
      })
    };
  }

  getListOfLastUsedDocuments(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentDashboard/GetLastViewed`, this.httpOptions);
  }

  getListOfFavoriteDocuments(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentDashboard/GetFavorites`, this.httpOptions);
  }

  getListOfLastChangedDocuments(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentDashboard/GetLastChanged`, this.httpOptions);
  }

  getListAffiliatedDocuments(parameters: any): Observable<any> {
    const url = `${this.configService.config.documentUrl}/api/DocumentDashboard/GetAffiliatedCards?resourceNumber=${parameters.resourceNumber}&equipmentNumber=${parameters.equipmentNumber}&SessionId=${parameters.SessionId}`;
    return this.http.get<any>(url, this.httpOptions);
  }

}
